import React from 'react';
import { MusicIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-navy px-5 py-16 text-center text-white md:py-24" data-id="element-57" data-mp="3n4wbi69tcnm3">
      <Reveal className="mx-auto max-w-3xl" data-id="element-58" data-mp="3s2xxayymj119">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-white/10 text-brand-orange" data-id="element-59" data-mp="wek5d5beyzs">
          <MusicIcon className="h-7 w-7" strokeWidth={1.5} aria-hidden="true" data-id="element-60" data-mp="2zejum5wlbgjd" />
        </div>
        <h2 className="mt-7 text-3xl font-extrabold leading-tight md:text-5xl" data-id="element-61" data-mp="34dn17us7xutg">
          Bereit, jeder Klasse{' '}
          <span className="italic text-brand-orange" data-id="element-62" data-mp="39awpv87sa2g8">Musik</span>{' '}
          näherzubringen?
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-white/70 md:text-base" data-id="element-63" data-mp="3e3y8nrb42m53">
          10 Bände + 6 exklusive Boni – sofort einsetzbar, für nur 19 €.
        </p>
        <div className="mt-10" data-id="element-64" data-mp="2lkswrus81l3h">
          <CTAButton data-id="element-65" data-mp="2ljzjsc2o5zcw" />
        </div>
      </Reveal>
    </section>;
}